import { useLayoutEffect, useRef } from "react";
import { cn } from "@/lib/utils";

// Mehrzeiliges Feld, das mit dem Inhalt wächst (JS-Höhenanpassung → funktioniert in Safari und Chrome).
// Enter = neue Zeile (Standard-Verhalten des Textfelds); einzeilig ist es exakt so hoch wie ein h-8-Input.
export function AutoTextarea({ value, className, onFocus, ...rest }) {
  const ref = useRef(null);
  const fit = () => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${el.scrollHeight + el.offsetHeight - el.clientHeight}px`;
  };
  useLayoutEffect(fit, [value]);
  return (
    <textarea ref={ref} rows={1} value={value ?? ""} onFocus={(e) => { fit(); onFocus?.(e); }}
      className={cn("block w-full min-h-8 max-h-64 resize-none overflow-y-auto rounded-md border border-input bg-transparent px-3 py-[5px] text-sm leading-5 shadow-sm transition-colors",
        "placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50", className)}
      {...rest} />
  );
}
